import { DisabledTag, Icon, BackgroundIcon } from '@nile/components';
import React from 'react';
import { Tooltip } from '@superops/ui-design-system';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const DetailHolderTag = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: flex-start;
  max-width: 20%;
  .titleHolder {
    color: #00000099;
    font-size: 1.4rem;
    // font-weight: 500;
  }
  .content {
    /* margin-top: 1rem; */
    align-items: center;
    width: calc(100% - 10px);
    .value {
      color: #000000cc;
      font-size: 1.4rem;
      font-weight: 700;
      &.value-na {
        font-weight: 400;
      }
    }
  }
`;

const renderMilestones = (completed, total) => {
  if (!total) {
    return (
      <DisabledTag className="ml-10">
        <FormattedMessage id="project.details.milestone.NA" />
      </DisabledTag>
    );
  }
  return <div className="value ml-10">{`${completed} / ${total}`} </div>;
};

const MilestoneHolder = ({ title, icon, completed, total }) => {
  return (
    <DetailHolderTag>
      <div className="fx content">
        <Tooltip content={<div>{title}</div>}>
          <div className="opacity5">
            <SVGIcon name={icon} />
          </div>
        </Tooltip>
        {renderMilestones(completed, total)}
      </div>
    </DetailHolderTag>
  );
};

export default MilestoneHolder;
